import { Injectable } from "@angular/core";
import { isDevMode } from '@angular/core';

@Injectable()
export class ErrorsService {

    private static readonly ERROR_DEV_APPEND_PREFIX = "(вы видите детальную ошибку, т.к. проект работает в DEV-режиме)";

    constructor() {}

    /**
     * Сгенерировать ошибку из полученных сообщений и вернуть скомпилированный результат
     * @param {string} message
     * @param {string} dev_message
     * @param {string} separator
     * @param {boolean} console_log
     * @returns {string}
     */
    public getError(message: string, dev_message?: string, separator: string = ' ', console_log: boolean = true): string
    {
        let error_message = message + (isDevMode && dev_message
            ? ':' + separator + '"' + dev_message + '"' + separator + ErrorsService.ERROR_DEV_APPEND_PREFIX
            : '.'
        );

        if (console_log)
        {
            console.log(error_message);
        }

        return error_message;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/errors.service.ts